import React from 'react';

import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';

import { Grid } from '@material-ui/core';

import { AIToolsAboutCard } from './AIToolsAboutCard';
import { ActionContent } from './ActionContent';
import { EntityWarningContent } from './EntityWarningContent';

export const AIToolsOverviewContent = () => {
  return (
    <Grid container spacing={3} alignItems="stretch">
      <EntityWarningContent />
      {ActionContent}

      <Grid item md={6}>
        <AIToolsAboutCard />
      </Grid>

      <Grid item md={6} xs={12}>
        <EntityCatalogGraphCard variant="gridItem" height={400} />
      </Grid>
    </Grid>
  );
};
